import { render } from "./RobotView.vue?vue&type=template&id=0f4f98ce"
import script from "./RobotView.vue?vue&type=script&lang=js"
export * from "./RobotView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/terrencewong/ispeech/ispeech-web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__